module.exports = __webpack_public_path__ + "img/Journalisma5.377309c8.png";